import { AsModuleHelper, AsStoreModule } from '@/types/vuex/helpers';
import { createNamespacedHelpers, ActionContext, MutationTree, Dictionary } from 'vuex';
import { Theme } from '@/types/theme';
import { IRootState } from '@/store/rootstate';
import {
  ITextOverrides,
  ISignupPage,
  ISignupAppConfig,
  ISignupFooter,
  IClientConfigsSettings,
} from '@/api/signup/interface';

interface IState {
  theme?: Theme & object;

  access: {
    frequency: string;
    reason: string;
    period: string;
    dataType: string;
    daysOfTransactions: number;
  };

  client: {
    name?: string;
    brand?: string;
    logo?: string;
    logoSmall?: string;
  };

  termsConditions?: string;
  privacyPolicy?: string;
  privacyNotice?: string;

  textOverrides: Partial<ITextOverrides>;
  i18n: {
    available?: string[];

    current?: string;
  };

  config?: ISignupAppConfig;
  clientConfigs: Partial<IClientConfigsSettings>;
  consentTermPrivacyCheckbox: boolean;
}

interface IGetters {
  allowedProviders: number[];
  allowChangeProvider: boolean;
  disableNewTab: boolean;
  allowDownloadPdf: boolean;

  providers: {
    openBanking: boolean;
    yodlee: boolean;
    starling: boolean;
    trueLayer: boolean;
  };

  brand: string,
  client: string;
  logo: string;
  logoXs: string;

  accessFrequency: string;
  accessReason: string;
  accessPeriod: string;
  accessDataType: string;
  daysOfTransactions: number;
  consentTermPrivacyCheckbox: boolean;

  termsConditions: string;
  privacyPolicy: string;
  privacyNotice: string;

  allowAddBank: boolean;
  allowClose: boolean;
  autoRedirect: boolean;
  showSuccessIcon: boolean;
  showSuccessSubTitle: boolean;

  themeStyle: { [k: string]: string };

  textOverrides: ITextOverrides;

  locale: {
    available: string;
    current: string;
  };

  footer?: ISignupFooter;

  pages: ISignupPage[];

  config?: ISignupAppConfig;
  clientConfigs: IClientConfigsSettings;

  termsAndConditionPage: string;
  noHeader: boolean;
  noBurgerMenu: boolean;
  noFooter: boolean;
  showTips: boolean;
  applyPlusSignUp:boolean;
  errorAutoRedirectEnabled: boolean;
  errorRedirectUrl: string;
  thirdPartyIntegrationApp: boolean;
  earlyRedirectEnabled: boolean;
  backButton: string;
  backButtonUrl: string;
  isBacktoClientEnabled: boolean;
  isIframeJourney: boolean;

}

/* Actions */
interface IActions {
  init(): Promise<any>;
  setTheme(theme: Partial<Theme> & object): Promise<any>;
  setClientConfigs(config: Partial<IClientConfigsSettings>): void;
  // fieldVisible(name: keyof ISignupField): boolean;
  // fieldEnabled(name: keyof IUserInfo): boolean;
}
interface IStoreActions<S, R> {
  init(injectee: ActionContext<S, R>): Promise<any> | void;
  setTheme(injectee: ActionContext<S, R>, theme: Partial<Theme> & object): Promise<any> | void;
  setClientConfigs(injectee: ActionContext<S, R>, about: Partial<IClientConfigsSettings>): void;

  // fieldVisible(
  //   injectee: ActionContext<S, R>,
  //   name: keyof ISignupField,
  // ): boolean;
  // fieldEnabled(injectee: ActionContext<S, R>, name: keyof IUserInfo): boolean;
}
/* /Actions */

export enum Mutations {
  UPDATE_THEME = 'updateTheme',
  UPDATE_EVERYTHING_TEMP = 'UPDATE_EVERYTHING_TEMP',
  UPDATE_CLIENT = 'UPDATE_CLIENT',
  UPDATE_TEXT_OVERRIDES = 'UPDATE_TEXT_OVERRIDES',
  SET_CLIENT_CONFIG = 'SET_CLIENT_CONFIG',
  UPDATE_APP_CONFIG = 'UPDATE_APP_CONFIG',
  UPDATE_LOCALE = 'UPDATE_LOCALE',
}

type MutationType<S, E, K = keyof keyof E> = { [k in keyof K]: MutationTree<S> };

export type module = AsStoreModule<
  IState,
  IGetters,
  IStoreActions<IState, IRootState>,
  MutationType<IState, Mutations>
>;
export default createNamespacedHelpers('settings') as AsModuleHelper<IState, IGetters, IActions>;
